import "core-js/modules/es.array.concat";
import "core-js/modules/es.object.to-string";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { searchdataAll } from "@/api/dataAll/dataAll";
import { tabulation } from "@/mixins/index";
export default {
  name: "dataAll",
  mixins: [tabulation],
  data: function data() {
    return {
      more: true,
      value1: [],
      value2: [],
      tableData: [],
      show: false,
      Dynamic: [{
        label: this.$t('startLoadUserCount'),
        prop: "load"
      }, {
        label: this.$t('loadCompleteCount'),
        prop: "load_complete"
      }, {
        label: this.$t('crashAbortLoadCount'),
        prop: "crash_abort_load"
      }, {
        label: this.$t('manualAbortLoadCount'),
        prop: "device_manual_abort_init"
      }, {
        label: this.$t('startInitDeviceCount'),
        prop: "device_init"
      }, {
        label: this.$t('startInitAccountCount'),
        prop: "account_init"
      }, {
        label: this.$t('initCompleteDeviceCount'),
        prop: "device_init_complete"
      }, {
        label: this.$t('initCompleteAccountCount'),
        prop: "account_init_complete"
      }, {
        label: this.$t('initCrashAbortDeviceCount'),
        prop: "device_crash_abort_init"
      }, {
        label: this.$t('initCrashAbortAccountCount'),
        prop: "account_crash_abort_init"
      }, {
        label: this.$t('initManualAbortDeviceCount'),
        prop: "device_manual_abort_init"
      }, {
        label: this.$t('initManualAbortAccountCount'),
        prop: "account_manual_abort_init"
      }],
      intReq: ["getCountrys"]
    };
  },
  created: function created() {},
  methods: {
    searchClick: function searchClick() {
      var _this = this;

      this.searchData.activation_time = "";
      this.searchData.activation_endtime = "";

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      this.reqLoading = true;
      searchdataAll(this.searchData).then(function (res) {
        if (res.status == 200) {
          _this.tableData = res.data.data;

          _this.$nextTick(function () {
            _this.getTableRight();
          });
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('date'),
        prop: "date"
      }].concat(_toConsumableArray(this.Dynamic));
      var data = this.tableData;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};